import { create } from 'zustand';
import type { ImportPreviewResult } from 'modules/questionBank/api';

interface ImportReviewState {
  preview: ImportPreviewResult | null;
  /** The Question Bank's subject filter when the file was uploaded; pre-fills the destination. */
  defaultSubjectId: string | undefined;
  start: (preview: ImportPreviewResult, defaultSubjectId?: string) => void;
  clear: () => void;
}

/**
 * Hands a parsed file from the upload modal to the review page.
 *
 * Deliberately not persisted: a parsed batch can run to thousands of rows, and
 * the edits made on the page live nowhere else until Add to bank. A reload
 * lands back on the Question Bank and the file is uploaded again.
 */
export const useImportReviewStore = create<ImportReviewState>((set) => ({
  preview: null,
  defaultSubjectId: undefined,
  start: (preview, defaultSubjectId) => set({ preview, defaultSubjectId }),
  clear: () => set({ preview: null, defaultSubjectId: undefined }),
}));
